const SET_ADVERTISER_NAME =
  'adAdvertiserCreatePaymentScreen/SET_ADVERTISER_NAME';
const SET_ADVERTISER_EMAIL_ADDRESS =
  'adAdvertiserCreatePaymentScreen/SET_ADVERTISER_EMAIL_ADDRESS';
const SET_IS_FETCHING = 'adAdvertiserCreatePaymentScreen/SET_IS_FETCHING';
const SET_IS_PAYMENT_SUCCESSFUL =
  'adAdvertiserCreatePaymentScreen/SET_IS_PAYMENT_SUCCESSFUL';

export default {
  SET_ADVERTISER_NAME,
  SET_ADVERTISER_EMAIL_ADDRESS,
  SET_IS_FETCHING,
  SET_IS_PAYMENT_SUCCESSFUL,
};
